import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages } from 'react-intl';

import Button from 'components/Button';
import Message from 'components/Message';
import { ICONS, ILLUSTRATIONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import Isvg from 'react-inlinesvg';

import './SmartSpotONConfirmModal.scss';

const messages = defineMessages({
  title: {
    id: 'smart-tools-v2.smart-spot-on-confirm-modal.title',
    defaultMessage: 'Please confirm you wish to turn SmartSpot on',
  },
  description: {
    id: 'smart-tools-v2.smart-spot-on-confirm-modal.description',
    defaultMessage: 'SmartSpot improves its accuracy typically after 3-4 weeks learning from your class demand.',
  },
  cancel: {
    id: 'smart-tools-v2.smart-spot-on-confirm-modal.cancel',
    defaultMessage: 'Cancel',
  },
  turnOn: {
    id: 'smart-tools-v2.smart-spot-on-confirm-modal.turn-on',
    defaultMessage: 'Turn On',
  },
});

const { block, element } = bem('smart-spot-on-confirm-modal');

const SmartSpotONConfirmModal = ({ closeModal, onConfirm }) => {
  const handleCancelClick = () => {
    closeModal();
  };

  const handleTurnOnClick = () => {
    onConfirm();
    closeModal();
  };

  return (
    <>
      <div className={block()}>
        <div className={element('header')}>
          <Isvg src={ICONS.cross} className={element('close-icon')} onClick={handleCancelClick} />
          <div className={element('image-container')}>
            <Isvg src={ILLUSTRATIONS.dotGraph} className={element('image')} />
          </div>
        </div>

        <div className={element('content')}>
          <div className={element('text-container')}>
            <h2 className={element('title')}>
              <Message message={messages.title} />
            </h2>
            <p className={element('description')}>
              <Message message={messages.description} />
            </p>
          </div>
          <div className={element('button-group')}>
            <Button className={element('cancel-button')} styled="primary-outline" onClick={handleCancelClick}>
              <Message message={messages.cancel} />
            </Button>
            <Button className={element('turn-on-button')} styled="primary" onClick={handleTurnOnClick}>
              <Message message={messages.turnOn} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

SmartSpotONConfirmModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default SmartSpotONConfirmModal;
